<app-modal-filler-atom
  (click)="closeComment()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow max-h-85-screen bottom-0 md:bottom-auto md:top-0 md:flex md:justify-center md:items-center md:w-full md:h-full"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="mobileKeyboardOffset"
>
  <app-input-comment-atom
    [text]="title"
    [comment]="message ?? ''"
    (applyComment)="applyComment($event)"
    (closeComment)="closeComment()"
  ></app-input-comment-atom>
</div>
